import AnswerSheetTypeSubQuestionConnectionAnswer from './AnswerSheetTypeConnectionAnswer';

export default AnswerSheetTypeSubQuestionConnectionAnswer;
